
// export default DatePicker;
import { useState, useRef } from 'react';
import { DateRangePicker } from 'rsuite';
import { FaClock } from 'react-icons/fa';
import 'rsuite/dist/rsuite.min.css'; // Import RSuite CSS

const DatePicker = () => {
  const [showTimePicker, setShowTimePicker] = useState(false);

  // State to store the selected ranges
  const [timeRange, setTimeRange] = useState([new Date(), new Date()]); // Initial time range
  const [resetTime,setResetTime] = useState(true);
  // References to the containers where the picker will render
  const timePickerContainerRef = useRef(null);

  const reset = () => {
    setTimeRange([new Date(), new Date()]);
    setResetTime(true);
  }

  return (
    <div>
      <style>
        {`
                /* Hide the default DateRangePicker input */
                .rs-picker-input-group {
                    visibility: hidden !important;
                }
                /* Remove footer containing the OK button */
                  .rs-btn .rs-btn-primary .rs-btn-sm .rs-btn-disabled {
                    display: none !important;
                  }
                `}
      </style>

      <div className="picker-container w-full "> {/* Parent container */}
        {/* Custom Input for Time Picker */}
        <div ref={timePickerContainerRef} className="relative items-center">
          <span>
            <div  className='w-[280px] h-[40px] bg-[white] text-[#b2b2b2] items-center border border-[#dcdfe6] rounded flex group z-0'>
              <div onClick={() => setShowTimePicker(true)} className='w-[250px] h-full flex itmes-center'>
                <div className='flex flex-col justify-center'>
                <svg
                className="w-4 h-4 ml-3"
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
                data-testid="AccessTimeIcon"
                title="AccessTime"
                fill="#b2b2b2"
                >
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
                </svg>
                </div>
                <input
                  placeholder="Start Time"
                  className="w-[100px] h-full outline-none text-center text-[black]"
                  value={
                    !resetTime ? timeRange[0].toLocaleTimeString() : 'Start Time'
                  }
                />
                <div className='flex flex-col justify-center'>
                  <span>~</span>
                </div>
                <input
                  placeholder="End Time"
                  className="w-[100px] h-full outline-none text-center text-[black]"
                  value={
                    !resetTime ? timeRange[1].toLocaleTimeString() : 'End Time'
                  }
                />
              </div>
              {timeRange.length > 1 && (
                <div onClick={reset}  className='h-[40px] w-[40px] outline-none bg-[transparent] flex flex-col justify-center z-100 cursor-pointer'>
                  <svg
                    className="w-4 h-4 ml-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    focusable="false"
                    viewBox="0 0 24 24"
                    data-testid="HighlightOffIcon"
                    title="HighlightOff"
                    fill='#b2b2b2'
                  >
                    <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path>
                  </svg>
                </div>
              )}

            </div>
          </span>
          {showTimePicker && (
            <div className="absolute top-[10px] left-[-100px]">
              <DateRangePicker
                format="HH:mm:ss"
                caretAs={FaClock}
                value={timeRange}
                onChange={(newRange) => {setTimeRange(newRange);setResetTime(false)}} // Handle time range change
                open={true} // Keep it open when visible
                onClose={() => setShowTimePicker(false)} // Close on focus loss
                container={timePickerContainerRef.current} // Attach picker to container
                showTwoCalendar // Optional: Display one calendar view
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DatePicker;










